/**
 * @file 全局变量默认值覆盖处理
 */
if (!window.g_config) {
  window.g_config = {};
}
g_config.version = g_config.version || 'V5.2.0';
g_config.globalConfig = g_config.globalConfig || {};
g_config.modules = g_config.modules || [];
g_config.switchUserType = g_config.switchUserType || 3;
g_config.user = g_config.user || {}; // 用户信息
g_config.user.permissionGroups = g_config.user.permissionGroups || []; // 用户权限组信息
// 用户模块列表
g_config.user.moduleCodes = g_config.modules.map((one) => one.moduleCode);
// 用户菜单列表
g_config.user.menuCodes = g_config.modules
  .map(getMenuCode)
  .join(',')
  .split(',')
  .filter((v) => v);

g_config.userPreference = g_config.userPreference || {};

/**
 * 设置feature toggles
 * features: tenantSwitcher, languageSwitcher, applicationChannelDeployment, client3rdPartyAccount
 */
g_config.featureToggles = g_config.featureToggles || {};

// 语言
g_config.language = g_config.language || g_config.userPreference.language || 'zh-CN';

// 大版本动态修改版本号，避免服务器中数据版本未变动
g_apps.global = g_apps.global || {};
g_apps.global.version = `${g_config.version}_${g_apps.global.version || ''}_${
  g_config.globalConfig.frontGlobalVersion || ''
}`;

function getMenuCode(module) {
  if (module.menus) {
    return [module.menuCode, ...module.menus.map(getMenuCode)].filter((v) => v).join(',');
  }
  if (module.subMenus) {
    return [module.menuCode, ...module.subMenus.map(getMenuCode)].filter((v) => v).join(',');
  }
  return module.menuCode || '';
}

if (window.mirrorz && !window.antd) {
  window.antd = window.mirrorz;
}



// WEBPACK FOOTER //
// ./src/config/g_config.js